import Vue from 'vue'
import Vuex from 'vuex'
import { isLogin } from '~fetch/login'
import { loadSetting, getnum } from '~fetch/home'
import { SessionStorage } from '../utils'

// import news from './modules/news'
let modules = {}
const routerContext = require.context('./', true, /index\.js$/)
routerContext.keys().forEach(route => {
  // 如果是根目录的 index.js 、不处理
  if (route.startsWith('./index')) {
    return
  }
  const routerModule = routerContext(route)
  /**
  * 兼容 import export 和 require module.export 两种规范
  */
  let module = (routerModule.default || routerModule)
  modules[route] = module
})

Vue.use(Vuex)
const types = {
  IS_LOGIN: 'IS_LOGIN',
  LOAD_SETTING_DATA: 'LOAD_SETTING_DATA',
  CART_GETNUM: 'CART_GETNUM'
}
export default new Vuex.Store({
  state: {
    [types.IS_LOGIN]: null,
    [types.LOAD_SETTING_DATA]: null,
    [types.CART_GETNUM]: 0
  },
  mutations: {
    [types.IS_LOGIN]: (state, res) => {
      state[types.IS_LOGIN] = res
    },
    [types.LOAD_SETTING_DATA]: (state, res) => {
      state[types.LOAD_SETTING_DATA] = res
    },
    [types.CART_GETNUM]: (state, res) => {
      state[types.CART_GETNUM] = res
    }
  },
  actions: {
    [types.IS_LOGIN]: async ({ commit }) => {
      const res = await isLogin()
      return commit(types.IS_LOGIN, res)
    },
    [types.LOAD_SETTING_DATA]: async ({ commit }) => {
      const res = await loadSetting()
      SessionStorage.setItem(types.LOAD_SETTING_DATA, res)
      return commit(types.LOAD_SETTING_DATA, res)
    },
    [types.CART_GETNUM]: async ({ commit }, rand) => {
      const res = await getnum(rand)
      return commit(types.CART_GETNUM, res)
    }
  },
  getters: {
    getLoginStatus (state) {
      return state[types.IS_LOGIN]
    },
    getLoadSettingStatus (state) {
      return state[types.LOAD_SETTING_DATA] || SessionStorage.getItem(types.LOAD_SETTING_DATA)
    },
    getCartnum (state) {
      return state[types.CART_GETNUM]
    }
  },
  modules
})
